[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 6,
                "y": 8,
                "key": "xMSu7"
            },
            {
                "x": 5,
                "y": 8,
                "key": "4St2N"
            },
            {
                "x": 5,
                "y": 7,
                "key": "i1otH"
            },
            {
                "x": 4,
                "y": 7,
                "key": "RBCT-"
            },
            {
                "x": 4,
                "y": 4,
                "key": "6zmsi"
            },
            {
                "x": 5,
                "y": 4,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 5,
                "y": 3,
                "key": "Y_QtY"
            },
            {
                "x": 7,
                "y": 3,
                "key": "eS6qs"
            },
            {
                "x": 7,
                "y": 4,
                "key": "7_ovB"
            },
            {
                "x": 9,
                "y": 4,
                "key": "HUX5i"
            },
            {
                "x": 9,
                "y": 3,
                "key": "U9Yyn"
            },
            {
                "x": 11,
                "y": 3,
                "key": "87Arv"
            },
            {
                "x": 11,
                "y": 4,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 12,
                "y": 4,
                "key": "NjyBq"
            },
            {
                "x": 12,
                "y": 7,
                "key": "fSGPv"
            },
            {
                "x": 11,
                "y": 7,
                "key": "yISFx"
            },
            {
                "x": 11,
                "y": 8,
                "key": "VjHMM"
            },
            {
                "x": 9,
                "y": 8,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 9,
                "y": 9,
                "key": "SNZ-8"
            },
            {
                "x": 6,
                "y": 9,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]